import * as React from 'react';
import {
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalRoot,
  ModalClose,
  Button,
  UIHeading2,
  UIText1,
} from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as style from './FullCreditPriceModal.css';

interface IFullCreditPriceModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
}

export const FullCreditPriceModal: React.FC<IFullCreditPriceModalProps> = props => {
  const { open, onOpenChange, title, description } = props;

  const clickTrap = React.useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  }, []);

  if (!open) {
    return null;
  }

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalContent size="S" onClick={clickTrap}>
        <ModalCloseButton title="Закрыть" size="XS" theme="fill_light" icon={<IconActionClose16 />} />
        <ModalBody>
          <div className={style['layout']}>
            <UIHeading2>{title}</UIHeading2>
            <UIText1 whiteSpace="pre-wrap">{description}</UIText1>
          </div>
        </ModalBody>
        <ModalFooter>
          <ModalClose asChild>
            <Button fullWidth size="L">
              Понятно
            </Button>
          </ModalClose>
        </ModalFooter>
      </ModalContent>
    </ModalRoot>
  );
};
